import { PagesUrl } from 'core/Utils';
import { Anchor, Center, Text } from 'ui';

const TermsAndConditions = () => {
  return (
    <Center>
      <Text fz={10} c="gray">
        By creating an account you agree to our{' '}
        <Anchor
          href={`${window.location.origin}${PagesUrl.PRIVACY_POLICY}`}
          target="_blank"
          c="cobalt"
          fz="10px"
          underline="never"
          fw={600}
        >
          Privacy Policy
        </Anchor>{' '}
        &{' '}
        <Anchor
          href={`${window.location.origin}${PagesUrl.TERMS_of_SERVICE}`}
          target="_blank"
          c="cobalt"
          fz="10px"
          underline="never"
          fw={600}
        >
          Terms of Service
        </Anchor>
      </Text>
    </Center>
  );
};

export { TermsAndConditions };
